import config from '@config'

export function importerFileRequest(sessionId, fileName) {
    return fetch(`${config.api.importerFile.uri}?file_name=${fileName}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            sid: sessionId,
            Accept: 'text/plain',
        },
    })
        .then((resp) => resp.blob())
        .catch((err) => console.error(err)) // eslint-disable-line no-console
}
